<section class="page">
  <div class="container">
    <div class="page-wrapper">
      <div class="page-header">
        <h1 class="page-title">Empreendimentos</h1>
        <div class="page-header__buttons">
          <button
            mat-stroked-button
            color="warn"
            [disabled]="!selection.selected.length"
            (click)="deletarDatas()"
          >
            DELETAR ITENS
          </button>
          <a
            mat-raised-button
            color="primary"
            routerLink="/imobiliaria/empreendimentos/adicionar"
          >
            ADICIONAR
          </a>
        </div>
      </div>

      <div class="page-filters">
        <mat-form-field appearance="fill">
          <mat-label>Tipo Empreendimento</mat-label>
          <mat-select
            name="idTipoEmpreendimento"
            [(ngModel)]="idTipoEmpreendimento"
            (ngModelChange)="onTipoEmpreendimentoChange($event)"
          >
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="searchTiposEmpreendimento"
                name="searchTiposEmpreendimento"
                placeholderLabel="Pesquise aqui"
                noEntriesFoundLabel="Nenhum registro encontrado"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="
                let t of tiposEmpreendimento
                  | filter: searchTiposEmpreendimento:'nome';
                let i = index
              "
              [value]="t.id"
            >
              {{ t.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Status</mat-label>
          <mat-select
            name="status"
            [(ngModel)]="status"
            (ngModelChange)="onStatusChange($event)"
          >
            <mat-option>Selecionar</mat-option>
            <mat-option *ngFor="let e of empreendimentoStatus" [value]="e.value"
              >{{ e.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Tipo da oferta</mat-label>
          <mat-select
            name="tipoOferta"
            [(ngModel)]="tipoOferta"
            (ngModelChange)="onTipoOfertaChange($event)"
          >
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="let e of empreendimentoTiposOferta"
              [value]="e.value"
              >{{ e.label }}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Situação</mat-label>
          <mat-select
            name="situacao"
            [(ngModel)]="situacao"
            (ngModelChange)="onSituacaoChange($event)"
          >
            <mat-option>Selecionar</mat-option>
            <mat-option value="A">Ativo</mat-option>
            <mat-option value="I">Inativo</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="no-margin">
          <mat-label>Corretor</mat-label>
          <mat-select
            name="idUsuarioImobiliaria"
            [(ngModel)]="idUsuarioImobiliaria"
            (ngModelChange)="onUsuarioImobiliariaChange($event)"
            [disabled]="auth.user.tipo === 'C'"
          >
            <mat-option>
              <ngx-mat-select-search
                [(ngModel)]="searchUsuariosImobiliaria"
                name="searchUsuariosImobiliaria"
                placeholderLabel="Pesquise aqui"
                noEntriesFoundLabel="Nenhum registro encontrado"
              >
              </ngx-mat-select-search>
            </mat-option>
            <mat-option>Selecionar</mat-option>
            <mat-option
              *ngFor="
                let u of usuariosImobiliaria
                  | filter: searchUsuariosImobiliaria:'nome'
              "
              [value]="u.id"
            >
              {{ u.nome }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="page-table">
        <mat-form-field class="page-table__search">
          <input
            matInput
            [(ngModel)]="search"
            (ngModelChange)="filter($event)"
            placeholder="Pesquise aqui"
          />
          <button
            mat-button
            *ngIf="search"
            matSuffix
            mat-icon-button
            aria-label="Limpar"
            (click)="clearFilter()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div class="page-table-container">
          <div class="loading-shade" *ngIf="!isLoadingResults && !data.length">
            <div class="rate-limit-reached">Nenhum registro encontrado</div>
          </div>

          <div class="loading-shade" *ngIf="isLoadingResults">
            <mat-spinner></mat-spinner>
          </div>

          <table
            mat-table
            [dataSource]="data"
            matSort
            matSortActive="0"
            matSortDirection="asc"
          >
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="selection.hasValue() && isAllSelected()"
                  [indeterminate]="selection.hasValue() && !isAllSelected()"
                  [aria-label]="checkboxLabel()"
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)"
                  [aria-label]="checkboxLabel(row)"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="imagem">
              <th mat-header-cell *matHeaderCellDef>Imagem</th>
              <td mat-cell *matCellDef="let row">
                <img
                  [src]="global.imageUrl + row._imagemPrincipal"
                  *ngIf="row._imagemPrincipal"
                  alt="imagemPrincipal"
                  class="page-table-image"
                />
                <img
                  src="assets/image-placeholder.png"
                  *ngIf="!row._imagemPrincipal"
                  alt="imagemPrincipal"
                  class="page-table-image"
                />
              </td>
            </ng-container>

            <ng-container matColumnDef="1">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Nome</th>
              <td mat-cell *matCellDef="let row">{{ row.nome }}</td>
            </ng-container>

            <ng-container matColumnDef="2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Endereço
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.endereco }}, {{ row.numeroEndereco }}
                {{ row.complemento ? " - " + row.complemento : "" }} -
                {{ row.bairro }}, {{ row.cidade }} - {{ row.uf }},
                {{ row.cep | mask: "00000-000" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor</th>
              <td mat-cell *matCellDef="let row">
                {{ row.valor | currency: "BRL" }}
                {{ row.tipoOferta === "L" ? " /mensal" : "" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Imobiliária
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.imobiliaria?.nome }}
              </td>
            </ng-container>

            <ng-container matColumnDef="5">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Tipo Empreendimento
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.tipoEmpreendimento?.nome }}
              </td>
            </ng-container>

            <ng-container matColumnDef="6">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
              <td mat-cell *matCellDef="let row">
                {{ global.getEmpreendimentoStatusLabel(row.status) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="7">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Tipo da oferta
              </th>
              <td mat-cell *matCellDef="let row">
                {{ global.getEmpreendimentoTipoOfertaLabel(row.tipoOferta) }}
              </td>
            </ng-container>

            <ng-container matColumnDef="8">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                Situação
              </th>
              <td mat-cell *matCellDef="let row">
                {{ row.situacao == "A" ? "Ativo" : "Inativo" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row">
                <a
                  mat-icon-button
                  mat-button
                  matTooltip="Editar"
                  aria-label="Editar"
                  color="primary"
                  [routerLink]="['/imobiliaria/empreendimentos/editar', row.id]"
                >
                  <mat-icon>create</mat-icon>
                </a>
                <button
                  mat-icon-button
                  mat-button
                  matTooltip="Excluir"
                  aria-label="Excluir"
                  color="warn"
                  (click)="deletarData(row)"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator
            [length]="resultsLength"
            [pageSizeOptions]="[15, 25, 40, 50]"
            [pageSize]="15"
          >
          </mat-paginator>
        </div>
      </div>
    </div>
  </div>
</section>
